var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("a", { ref: "link", style: { display: "none" } }),
          _c(
            "v-row",
            { staticClass: "d-flex" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-center pb-0",
                  attrs: { cols: "2" }
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "close-on-content-click": false,
                        "content-class": "columnMenu"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "manage-btn btn",
                                      attrs: { text: "", small: "" }
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("Manage Columns")) + " "
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      class: { rotate: _vm.menuOpen },
                                      attrs: { right: "" }
                                    },
                                    [_vm._v(" mdi-chevron-down ")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.menuOpen,
                        callback: function($$v) {
                          _vm.menuOpen = $$v
                        },
                        expression: "menuOpen"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "column-card" },
                        [
                          _c("v-card-title", { staticClass: "column-header" }, [
                            _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                          ]),
                          _c("v-divider"),
                          _c(
                            "v-list",
                            { staticClass: "select-all", attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "input-value": _vm.isAllSelected,
                                      "hide-details": ""
                                    },
                                    on: { change: _vm.toggleSelectAll }
                                  }),
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Select All")) + " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            { staticClass: "column-list" },
                            [
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                _vm._l(_vm.shelfHeaders.slice(2), function(
                                  header
                                ) {
                                  return _c(
                                    "v-list-item",
                                    { key: header.value },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          value: header.text,
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.visibleColumns,
                                          callback: function($$v) {
                                            _vm.visibleColumns = $$v
                                          },
                                          expression: "visibleColumns"
                                        }
                                      }),
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "column-text" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(header.text) + " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            { staticClass: "column-footer" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-4",
                                  staticStyle: {
                                    background: "#c57171",
                                    color: "#ffffff !important",
                                    width: "80px"
                                  },
                                  attrs: {
                                    color: "error",
                                    text: "",
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.menuOpen = false
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { width: "80px" },
                                  attrs: { color: "primary", small: "" },
                                  on: { click: _vm.handleColumnSave }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-center",
                  attrs: { cols: "1" }
                },
                [_c("v-divider", { attrs: { vertical: "" } })],
                1
              ),
              _c("v-col", { attrs: { cols: "9" } }, [
                _c(
                  "section",
                  { staticClass: "searchArea" },
                  [
                    _c("v-select", {
                      staticClass: "form-select ml-3",
                      staticStyle: { width: "20%" },
                      attrs: {
                        items: _vm.floorItems,
                        label: _vm.$t("Floor"),
                        placeholder: _vm.$t("Select Floor"),
                        clearable: "",
                        outlined: "",
                        dense: "",
                        "persistent-hint": "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.searchBy.floor,
                        callback: function($$v) {
                          _vm.$set(_vm.searchBy, "floor", $$v)
                        },
                        expression: "searchBy.floor"
                      }
                    }),
                    _c("v-select", {
                      staticClass: "form-select ml-3",
                      staticStyle: { width: "20%" },
                      attrs: {
                        items: _vm.floorMap[_vm.searchBy.floor],
                        disabled: !_vm.searchBy.floor,
                        label: _vm.$t("Section"),
                        placeholder: _vm.$t("Select Section"),
                        clearable: "",
                        outlined: "",
                        dense: "",
                        "persistent-hint": "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.searchBy.section,
                        callback: function($$v) {
                          _vm.$set(_vm.searchBy, "section", $$v)
                        },
                        expression: "searchBy.section"
                      }
                    }),
                    _c("v-text-field", {
                      staticClass: "form-input ml-3",
                      staticStyle: { width: "20%" },
                      attrs: {
                        label: _vm.$t("Shelf Id"),
                        placeholder: _vm.$t("Input Shelf Id"),
                        outlined: "",
                        dense: "",
                        "hide-details": "",
                        clearable: ""
                      },
                      model: {
                        value: _vm.searchBy.shelfId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchBy, "shelfId", $$v)
                        },
                        expression: "searchBy.shelfId"
                      }
                    }),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn type-search ml-10",
                        staticStyle: { width: "120px" },
                        attrs: { text: "" },
                        on: { click: _vm.handleSearch }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                    )
                  ],
                  1
                ),
                _c(
                  "section",
                  { staticClass: "searchArea" },
                  [
                    _c("v-select", {
                      staticClass: "form-select ml-3",
                      staticStyle: { width: "20%" },
                      attrs: {
                        items: _vm.typeItems,
                        label: _vm.$t("Type"),
                        placeholder: _vm.$t("Select Type"),
                        clearable: "",
                        outlined: "",
                        dense: "",
                        "persistent-hint": "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.searchBy.type,
                        callback: function($$v) {
                          _vm.$set(_vm.searchBy, "type", $$v)
                        },
                        expression: "searchBy.type"
                      }
                    }),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "min-width": "290px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "form-input ml-3",
                                        staticStyle: { width: "20%" },
                                        attrs: {
                                          value: _vm.searchBy.startDate,
                                          label: "" + _vm.$t("Period"),
                                          placeholder:
                                            "" + _vm.$t("Select start date"),
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          readonly: "",
                                          clearable: ""
                                        },
                                        on: {
                                          "click:clear": function($event) {
                                            return _vm.clearDate(
                                              _vm.searchBy,
                                              "startDate"
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function() {
                                                return [
                                                  _c("img", {
                                                    attrs: {
                                                      width: "16",
                                                      height: "16",
                                                      src: require("@/assets/img/ico-calendar.png")
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      "v-text-field",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.showStartDatePicker,
                          callback: function($$v) {
                            _vm.showStartDatePicker = $$v
                          },
                          expression: "showStartDatePicker"
                        }
                      },
                      [
                        _c("v-date-picker", {
                          attrs: {
                            locale:
                              _vm.languageCodes[
                                _vm.$store.getters[
                                  "dataStore/GET_CURRENT_LANGUAGE"
                                ]
                              ],
                            "no-title": ""
                          },
                          on: {
                            change: _vm.checkStartDate,
                            input: function($event) {
                              _vm.showStartDatePicker = false
                            }
                          },
                          model: {
                            value: _vm.searchBy.startDate,
                            callback: function($$v) {
                              _vm.$set(_vm.searchBy, "startDate", $$v)
                            },
                            expression: "searchBy.startDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("~")]),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "min-width": "290px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "form-input",
                                        staticStyle: { width: "20%" },
                                        attrs: {
                                          value: _vm.searchBy.endDate,
                                          placeholder:
                                            "" + _vm.$t("Select end date"),
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          solo: "",
                                          readonly: "",
                                          clearable: ""
                                        },
                                        on: {
                                          "click:clear": function($event) {
                                            return _vm.clearDate(
                                              _vm.searchBy,
                                              "endDate"
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function() {
                                                return [
                                                  _c("img", {
                                                    attrs: {
                                                      width: "16",
                                                      height: "16",
                                                      src: require("@/assets/img/ico-calendar.png")
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      "v-text-field",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.showEndDatePicker,
                          callback: function($$v) {
                            _vm.showEndDatePicker = $$v
                          },
                          expression: "showEndDatePicker"
                        }
                      },
                      [
                        _c("v-date-picker", {
                          attrs: {
                            locale:
                              _vm.languageCodes[
                                _vm.$store.getters[
                                  "dataStore/GET_CURRENT_LANGUAGE"
                                ]
                              ],
                            "no-title": ""
                          },
                          on: {
                            change: _vm.checkEndDate,
                            input: function($event) {
                              _vm.showEndDatePicker = false
                            }
                          },
                          model: {
                            value: _vm.searchBy.endDate,
                            callback: function($$v) {
                              _vm.$set(_vm.searchBy, "endDate", $$v)
                            },
                            expression: "searchBy.endDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn type-search ml-10",
                        staticStyle: { width: "120px" },
                        attrs: { text: "" },
                        on: { click: _vm.clearSearch }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "tbl-type01 mt-4",
        attrs: {
          headers: _vm.filteredHeaders,
          items: _vm.issueList,
          "hide-default-footer": true,
          "show-select": ""
        },
        scopedSlots: _vm._u([
          {
            key: "item.type",
            fn: function(ref) {
              var item = ref.item
              return [_c("div", [_vm._v(_vm._s(_vm.textPicker(item.type)))])]
            }
          },
          {
            key: "item.location",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " + _vm._s(item.floor) + "_" + _vm._s(item.shelfId) + " "
                )
              ]
            }
          },
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "div",
                  {
                    style: {
                      color:
                        item.status.toLowerCase() === "open"
                          ? "orange"
                          : item.status.toLowerCase() === "resolved"
                          ? "green"
                          : item.status.toLowerCase() === "pending"
                          ? "#c17f00"
                          : "gray",
                      fontWeight: "bold"
                    }
                  },
                  [_vm._v(" " + _vm._s(item.status) + " ")]
                )
              ]
            }
          },
          {
            key: "item.duration",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.createdAt
                        ? _vm.convertDate(new Date() - new Date(item.createdAt))
                        : ""
                    ) +
                    " "
                )
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                item.status.toLowerCase() === "open"
                  ? [
                      _c(
                        "div",
                        { staticClass: "action-group" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actions",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmUpdateStatus(
                                                      item,
                                                      "rejected"
                                                    )
                                                  }
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                  color: "#BE4653"
                                                },
                                                attrs: { size: "18" }
                                              },
                                              [_vm._v("mdi-close")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("Reject")))])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actions",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmUpdateStatus(
                                                      item,
                                                      "resolved"
                                                    )
                                                  }
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                  color: "#1D6E35"
                                                },
                                                attrs: { size: "18" }
                                              },
                                              [_vm._v("mdi-check")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("Resolve")))])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actions",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmUpdateStatus(
                                                      item,
                                                      "pending"
                                                    )
                                                  }
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                  color: "#c17f00"
                                                },
                                                attrs: { size: "18" }
                                              },
                                              [_vm._v("mdi-clock-outline")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("Pending")))])]
                          )
                        ],
                        1
                      )
                    ]
                  : item.status.toLowerCase() === "pending"
                  ? [
                      _c(
                        "div",
                        { staticClass: "action-group" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actions",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmUpdateStatus(
                                                      item,
                                                      "rejected"
                                                    )
                                                  }
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                  color: "#BE4653"
                                                },
                                                attrs: { size: "18" }
                                              },
                                              [_vm._v("mdi-close")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("Reject")))])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actions",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmUpdateStatus(
                                                      item,
                                                      "resolved"
                                                    )
                                                  }
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                  color: "#1D6E35"
                                                },
                                                attrs: { size: "18" }
                                              },
                                              [_vm._v("mdi-check")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("Resolve")))])]
                          )
                        ],
                        1
                      )
                    ]
                  : item.status.toLowerCase() === "no_issue"
                  ? [
                      _c(
                        "div",
                        { staticClass: "action-group" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actions",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmUpdateStatus(
                                                      item,
                                                      "reOpen"
                                                    )
                                                  }
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "margin-right": "5px",
                                                  color: "#2C8CC4"
                                                },
                                                attrs: { size: "18" }
                                              },
                                              [_vm._v("mdi-reload")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("Reopen")))])]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.createdAt",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.createdAt ? _vm.formatTimeStamp(item.createdAt) : ""
                    ) +
                    " "
                )
              ]
            }
          },
          {
            key: "item.detail",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-icon",
                  {
                    attrs: { size: "18" },
                    on: {
                      click: function($event) {
                        return _vm.handleDetailClick(item)
                      }
                    }
                  },
                  [_vm._v("mdi-image-filter-center-focus-weak")]
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      }),
      _c(
        "v-row",
        { staticClass: "mt-4" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-space-between align-end",
              attrs: { cols: "12" }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn mr-2",
                      attrs: {
                        text: "",
                        disabled:
                          _vm.btnDisabledExport || _vm.issueList.length === 0
                      },
                      on: { click: _vm.handleExport }
                    },
                    [_vm._v(_vm._s(_vm.$t("Export")) + " ")]
                  ),
                  _c("BlinkLedModal", {
                    attrs: {
                      btnDisabledBlinking:
                        !_vm.selected.length || _vm.btnDisabledBlinking,
                      selectedLabel: _vm.selectedLabel
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("Pagination", {
                    attrs: {
                      pageInfoText: _vm.pageInfoText,
                      pageIndex: _vm.pageIndex,
                      rowPerPage: _vm.rowPerPage,
                      goToPageInput: _vm.goToPageInput,
                      totalPages: _vm.totalPages
                    },
                    on: {
                      paging: function($event) {
                        return _vm.paging($event)
                      },
                      updatePage: function($event) {
                        return _vm.updatePage($event)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.showShelfImage
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                "retain-focus": false,
                "max-width": "900",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.showShelfImage,
                callback: function($$v) {
                  _vm.showShelfImage = $$v
                },
                expression: "showShelfImage"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "d-flex flex-column zoom-dialog-card" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "64px",
                        "background-color": "#001E38",
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        padding: "0 16px"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                            small: "",
                            disabled: _vm.shelfStatusZoom <= 0.25,
                            title: _vm.$t("Zoom Out")
                          },
                          on: { click: _vm.zoomOut }
                        },
                        [_c("v-icon", [_vm._v("mdi-magnify-minus-outline")])],
                        1
                      ),
                      _c("span", { staticClass: "zoom-label" }, [
                        _vm._v(
                          _vm._s(Math.round(_vm.shelfStatusZoom * 100)) + "%"
                        )
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                            small: "",
                            disabled: _vm.shelfStatusZoom >= 5,
                            title: _vm.$t("Zoom In")
                          },
                          on: { click: _vm.zoomIn }
                        },
                        [_c("v-icon", [_vm._v("mdi-magnify-plus-outline")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                            small: "",
                            title: _vm.$t("Reset Zoom")
                          },
                          on: { click: _vm.resetZoom }
                        },
                        [_c("v-icon", [_vm._v("mdi-magnify-close")])],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: { click: _vm.handleClose }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      ref: "imageViewport",
                      staticClass: "image-viewport",
                      style: { cursor: _vm.isDragging ? "grabbing" : "grab" },
                      on: {
                        wheel: function($event) {
                          $event.preventDefault()
                          return _vm.onWheel($event)
                        },
                        mousedown: function($event) {
                          $event.preventDefault()
                          return _vm.onMouseDown($event)
                        },
                        mousemove: _vm.onMouseMove,
                        mouseup: _vm.onMouseUp,
                        mouseleave: _vm.onMouseUp
                      }
                    },
                    [
                      _vm.selectedShelfImage
                        ? _c("img", {
                            staticClass: "zoomable-image",
                            style: {
                              transform:
                                "translate(" +
                                _vm.translateX +
                                "px, " +
                                _vm.translateY +
                                "px) scale(" +
                                _vm.shelfStatusZoom +
                                ")",
                              transformOrigin: "0 0"
                            },
                            attrs: { src: _vm.selectedShelfImage },
                            on: {
                              load: _vm.onImageLoad,
                              dragstart: function($event) {
                                $event.preventDefault()
                              }
                            }
                          })
                        : _c("div", { staticClass: "no-image-placeholder" }, [
                            _vm._v(_vm._s(_vm.$t("No Image Available")))
                          ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }